import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

const EmptyRow = () => {
  return (
    <Box gap="s8" flexDirection="row" alignItems="center">
      <Box width="s80" flexDirection="row" justifyContent="flexEnd" />
      <Box width="s140" />
      <Box width="s120" />
      <Box
        gap="s8"
        minWidth="s240"
        width="full"
        flexDirection="row"
        alignItems="center"
        justifyContent="flexEnd"
      />
    </Box>
  )
}

export default observer(EmptyRow)
